import { ChangeEvent, useCallback, useMemo, useState } from 'react'
import { MatchingPaymentActiveTicketsFilters } from '../../core/_models'

type Filters = MatchingPaymentActiveTicketsFilters

type FilterFormState = {
  search?: MatchingPaymentActiveTicketsFilters['search']
}

interface Props {
  defaultFilters: Filters
  applyFilters: (filters: Filters) => void
  visibility: Record<string, boolean>
  initialSearch?: string
}

const ActivePaymentTicketsFilter = ({ defaultFilters, applyFilters, visibility, initialSearch }: Props) => {
  const defaultFormState: FilterFormState = useMemo(
    () => ({
      search: visibility?.ticketToken ? initialSearch || defaultFilters?.search || undefined : undefined,
    }),
    [defaultFilters, visibility, initialSearch]
  )

  const isFilterFormVisible = useMemo(() => {
    return visibility?.ticketToken
  }, [visibility])

  const [formState, setFormState] = useState<FilterFormState>(defaultFormState)

  const handleTicketSearchChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    setFormState((prev: FilterFormState) => ({ ...prev, search: value || undefined }))
  }, [])

  const handleApplyFilters = () => {
    applyFilters({
      ...(defaultFilters || {}),
      search: formState?.search || undefined,
    })
  }

  const handleReset = useCallback(() => {
    setFormState(defaultFormState)
    applyFilters({ ...(defaultFilters || {}) })
  }, [applyFilters, defaultFilters, defaultFormState])

  if (!isFilterFormVisible) return null

  return (
    <div className='card mb-7'>
      <div className='card-body border-0 pt-5'>
        <div className='d-flex flex-column w-100 gap-4 flex-xl-row gap-xl-12 align-items-xl-center'>
          <div className='d-flex flex-column gap-4 w-100 flex-md-row'>
            {!!visibility.ticketToken && (
              <div className='position-relative w-100'>
                <span className='svg-icon svg-icon-3 svg-icon-gray-500 position-absolute pt-4 ms-3'>
                  <i className='fa fa-search'></i>
                </span>
                <input
                  type='text'
                  name='ticketSearch'
                  className='form-control form-control-solid ps-10 pt-3 pb-2'
                  onChange={handleTicketSearchChange}
                  placeholder='ID тикета или ID транзакции'
                  value={formState.search || ''}
                />
              </div>
            )}
          </div>

          <div className='d-flex gap-4 align-items-md-start flex-column flex-sm-row justify-content-sm-end'>
            <button className='btn btn-success' onClick={handleApplyFilters}>
              Фильтровать
            </button>
            <button className='btn btn-primary' onClick={handleReset}>
              Сбросить&nbsp;фильтр
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ActivePaymentTicketsFilter
